import { toast } from 'sonner';

import { utilEventCartModal } from '@/fo/util/event-cart-modal';

import { UiToastAdded } from '../UiToastAdded';

import type { ToastCartAddedParams } from './types';

export const toastCartAdded = ({
  src,
  subtitle,
  position = 'top-right',
  style,
  title,
  buttonText
}: ToastCartAddedParams) => {
  toast.custom(
    () => (
      <div
        style={{ pointerEvents: 'auto' }}
        onClick={() => {
          toast.dismiss();
        }}
      >
        <UiToastAdded
          src={src}
          subtitle={subtitle}
          title={title}
          buttonText={buttonText}
          onButtonClick={() => utilEventCartModal.open()}
        />
      </div>
    ),
    { position, style }
  );
};
